import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { FocusTrap } from '@mui/base';
import { Box, ClickAwayListener, Popper } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Dropdown wrapping component.
 * Can contain any child element.
 */
export const Dropdown = ({ anchorEl, children, dataId, enableClickAway = true, enableFocusTrap = true, enableAutoFocus = true, id, height = 400, offset = [0, 8], onClose, onFocusOpen, onScroll, open = false, overflowHidden = false, placement = 'bottom-start', style, modifiers, }) => {
    /**
     * Handler called when the user clicks away from the dropdown.
     */
    const handleOnClickAway = () => {
        if (enableClickAway)
            onClose();
    };
    /**
     * Handler called when a key is pressed in the dropdown.
     * @param e The event.
     */
    const handleOnKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            onClose();
        }
    };
    useEffect(() => {
        if (open && onFocusOpen) {
            onFocusOpen();
        }
    }, [open, onFocusOpen]);
    return (_jsx(Popper, Object.assign({ "aria-labelledby": id, "data-id": `${dataId}-popper`, anchorEl: anchorEl, id: id, modifiers: modifiers !== null && modifiers !== void 0 ? modifiers : [
            {
                name: 'offset',
                enabled: true,
                options: { offset },
            },
        ], onKeyDown: handleOnKeyDown, onScroll: onScroll, open: open, placement: placement, role: "listbox", sx: Object.assign({ backgroundColor: HelixPalette.white, borderRadius: '0.5rem', boxShadow: HelixStyles.elevationMD, maxHeight: height, overflow: overflowHidden ? 'hidden' : 'auto', zIndex: 1201 }, style) }, { children: _jsx(ClickAwayListener, Object.assign({ onClickAway: handleOnClickAway }, { children: _jsx(Box, Object.assign({ "data-id": `${dataId}-click-away-wrapper`, maxHeight: height, overflow: "hidden", tabIndex: -1, sx: { '&:focus-visible': { outline: 'none' } } }, { children: _jsx(FocusTrap, Object.assign({ open: enableFocusTrap && open, disableAutoFocus: !enableAutoFocus }, { children: _jsx(Box, Object.assign({ "data-id": `${dataId}-focus-trap-wrapper`, maxHeight: height, overflow: "hidden", tabIndex: -1, sx: { '&:focus-visible': { outline: 'none' } } }, { children: children })) })) })) })) })));
};
export default Dropdown;
